var _defs, _g, _g2, _path, _path2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrustrationsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "be4e0251e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 110.59375 L 729 110.59375 L 729 699.742188 L 81 699.742188 Z M 81 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "752cfc6544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.5 110.59375 L 661.5 110.59375 C 698.777344 110.59375 729 140.816406 729 178.09375 L 729 631.90625 C 729 669.183594 698.777344 699.40625 661.5 699.40625 L 148.5 699.40625 C 111.222656 699.40625 81 669.183594 81 631.90625 L 81 178.09375 C 81 140.816406 111.222656 110.59375 148.5 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ccb8bc3d28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203 267 L 613 267 L 613 543 L 203 543 Z M 203 267 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e39b84e37b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.296875 297.75 L 590.394531 247.910156 L 623.113281 512.570312 L 220.019531 562.40625 Z M 187.296875 297.75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4039888cbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.300781 297.746094 L 590.390625 247.910156 L 623.109375 512.570312 L 220.019531 562.40625 Z M 187.300781 297.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1c47f0340"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 416.164062 269.453125 C 420.585938 268.90625 425.035156 268.355469 429.449219 267.808594 C 465.175781 267.882812 488.980469 279.875 501.96875 302.714844 C 560.226562 292.253906 608.496094 332.507812 588.03125 380.402344 C 597.835938 388.722656 606.34375 398.335938 610.691406 412.109375 C 611.1875 416.148438 611.6875 420.175781 612.1875 424.210938 C 608.863281 461.046875 578.472656 489.417969 522.847656 489.671875 C 511.023438 509.835938 488.207031 531.382812 448.871094 533.914062 C 428.535156 535.203125 413.628906 529.933594 400.28125 522.945312 C 388.203125 531.617188 374.867188 538.902344 354.609375 541.46875 C 307.742188 547.371094 273.011719 523.996094 267.628906 486.707031 C 236.410156 481.6875 213.976562 467.890625 204.96875 440.644531 C 204.46875 436.605469 203.96875 432.558594 203.46875 428.539062 C 206.183594 400.101562 223.335938 380.328125 254.5625 368.984375 C 246.859375 322.53125 307.542969 285.410156 362.898438 299.449219 C 374.214844 287.722656 390.632812 274.429688 416.164062 269.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "815aa4ddbe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 339 331 L 364 331 L 364 387 L 339 387 Z M 339 331 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "500dd2902b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337.367188 333.238281 L 355.449219 329.503906 L 371.632812 407.851562 L 353.550781 411.585938 Z M 337.367188 333.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "28553af2ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337.367188 333.238281 L 355.449219 329.503906 L 371.632812 407.851562 L 353.550781 411.585938 Z M 337.367188 333.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f039ead127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 354 391 L 371 391 L 371 410 L 354 410 Z M 354 391 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb8f610489"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337.367188 333.238281 L 355.449219 329.503906 L 371.632812 407.851562 L 353.550781 411.585938 Z M 337.367188 333.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "365de1be81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337.367188 333.238281 L 355.449219 329.503906 L 371.632812 407.851562 L 353.550781 411.585938 Z M 337.367188 333.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae4f13b253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 289.359375 459.03125 L 316.027344 459.03125 L 316.027344 485.695312 L 289.359375 485.695312 Z M 289.359375 459.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "133d3fce46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 327 436 L 351 436 L 351 466 L 327 466 Z M 327 436 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "315280f68a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350.390625 465.964844 L 323.957031 462.457031 L 327.464844 436.023438 L 353.902344 439.53125 Z M 350.390625 465.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a3e207108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350.390625 465.964844 L 323.957031 462.457031 L 327.464844 436.023438 L 353.902344 439.53125 Z M 350.390625 465.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d59b73cce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 291 435 L 324 435 L 324 457 L 291 457 Z M 291 435 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9dd330c140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 323.765625 436.183594 L 317.285156 462.050781 L 291.417969 455.566406 L 297.898438 429.699219 Z M 323.765625 436.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ddef3bcc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 323.765625 436.183594 L 317.285156 462.050781 L 291.417969 455.566406 L 297.898438 429.699219 Z M 323.765625 436.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06d62a3759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318 467 L 352 467 L 352 488 L 318 488 Z M 318 467 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "adbac3ccb5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318.394531 487.101562 L 326.019531 461.546875 L 351.574219 469.171875 L 343.945312 494.726562 Z M 318.394531 487.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31029c73dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318.394531 487.101562 L 326.019531 461.546875 L 351.574219 469.171875 L 343.945312 494.726562 Z M 318.394531 487.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a24b08887"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 405.078125 331.703125 L 431.746094 331.703125 L 431.746094 358.371094 L 405.078125 358.371094 Z M 405.078125 331.703125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1659b9f656"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 442 308 L 467 308 L 467 339 L 442 339 Z M 442 308 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09e29e4b40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 466.109375 338.640625 L 439.671875 335.128906 L 443.179688 308.695312 L 469.617188 312.203125 Z M 466.109375 338.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7e1b80c87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 466.109375 338.640625 L 439.671875 335.128906 L 443.179688 308.695312 L 469.617188 312.203125 Z M 466.109375 338.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67d8798ffd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 407 308 L 440 308 L 440 330 L 407 330 Z M 407 308 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "16be8ac131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 439.484375 308.855469 L 433 334.722656 L 407.132812 328.238281 L 413.617188 302.371094 Z M 439.484375 308.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "28de8e3baa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 439.484375 308.855469 L 433 334.722656 L 407.132812 328.238281 L 413.617188 302.371094 Z M 439.484375 308.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "15d2870080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 434 340 L 467 340 L 467 361 L 434 361 Z M 434 340 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "769e74aac7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 434.109375 359.773438 L 441.734375 334.21875 L 467.289062 341.847656 L 459.664062 367.398438 Z M 434.109375 359.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa4fda6081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 434.109375 359.773438 L 441.734375 334.21875 L 467.289062 341.847656 L 459.664062 367.398438 Z M 434.109375 359.773438 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be4e0251e3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#752cfc6544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#397da2",
    d: "M 81 110.59375 L 729 110.59375 L 729 699.109375 L 81 699.109375 Z M 81 110.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ccb8bc3d28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e39b84e37b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4039888cbf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1c47f0340)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(2.037767, -0.251939, 0.252064, 2.038778, 187.299954, 297.747984)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 112.311173 0.000352663 C 114.481145 0.000267171 116.664566 -0.0000722455 118.830761 -0.000624368 C 136.094581 2.169131 146.883591 9.38633 151.796775 21.194266 C 180.580525 19.620193 201.505855 41.950144 188.75218 63.865909 C 192.994018 68.471117 196.531754 73.623504 197.810094 80.537205 C 197.808511 82.518128 197.809516 84.493624 197.810055 86.472894 C 194.002057 104.06998 177.617492 115.961014 150.716254 112.76127 C 143.796107 121.796391 131.480306 130.843007 112.316215 129.716384 C 102.409909 129.124498 95.519946 125.688429 89.486265 121.513229 C 83.129913 124.983134 76.248706 127.706094 66.30383 127.735966 C 43.298096 127.788105 27.908148 114.421114 27.534724 96.085061 C 12.745256 91.795444 2.726569 83.790172 0.000868244 70.089415 C 0.000563287 68.108258 0.000725191 66.123327 -0.000746921 64.151605 C 3.010836 50.575452 12.482963 42.047286 28.254048 38.432181 C 27.306742 15.530333 58.856146 1.221485 84.772984 11.31014 C 90.943472 6.320889 99.67338 0.879609 112.311173 0.000352663 ",
    stroke: "#fcfbfa",
    strokeWidth: 7.312299,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.254862, -1.65912, 1.636076, 1.237434, 419.25315, 444.903286)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.000543 1.999662 L 24.62706 2.000498 ",
    stroke: "#fcfbfa",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.868529, 0.745167, -0.759874, 1.905408, 422.293014, 438.68203)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.000864 2.000289 L 17.376727 2 ",
    stroke: "#fcfbfa",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.254862, -1.65912, 1.636076, 1.237434, 419.25315, 494.479219)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.999703 2.000306 L 24.62622 2.001142 ",
    stroke: "#fcfbfa",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#815aa4ddbe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#500dd2902b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28553af2ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 339.347656 340.8125 C 341.089844 351.265625 343.242188 361.679688 345.84375 372.007812 C 346.597656 374.902344 347.355469 377.800781 348.160156 380.6875 C 348.707031 382.578125 349.671875 384.230469 351.40625 385.324219 C 352.964844 386.304688 355.308594 386.820312 357.136719 386.34375 C 359.066406 385.84375 360.945312 384.855469 361.996094 383.136719 C 363.015625 381.523438 363.6875 379.484375 363.140625 377.59375 C 360.300781 367.367188 357.851562 357.011719 355.90625 346.601562 C 355.351562 343.664062 354.847656 340.714844 354.34375 337.765625 C 354.015625 335.929688 352.652344 334.109375 351.09375 333.128906 C 349.539062 332.148438 347.191406 331.632812 345.363281 332.109375 C 343.4375 332.609375 341.558594 333.597656 340.507812 335.316406 C 339.394531 336.996094 339.042969 338.824219 339.347656 340.8125 Z M 339.347656 340.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f039ead127)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb8f610489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#365de1be81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 370 400.203125 C 369.820312 399.339844 369.632812 398.429688 369.453125 397.5625 C 369.296875 396.546875 368.859375 395.683594 368.230469 394.914062 C 367.742188 394.0625 367.082031 393.398438 366.207031 392.929688 C 365.359375 392.355469 364.460938 392.039062 363.5 391.9375 C 362.511719 391.691406 361.515625 391.644531 360.476562 391.910156 C 359.84375 392.140625 359.167969 392.382812 358.527344 392.5625 C 357.347656 393.15625 356.378906 394.007812 355.617188 395.117188 C 355.316406 395.679688 355.015625 396.242188 354.765625 396.792969 C 354.292969 398.042969 354.253906 399.351562 354.519531 400.648438 C 354.699219 401.511719 354.886719 402.425781 355.066406 403.289062 C 355.222656 404.308594 355.664062 405.167969 356.289062 405.941406 C 356.777344 406.789062 357.4375 407.453125 358.316406 407.925781 C 359.164062 408.5 360.0625 408.816406 361.019531 408.917969 C 362.007812 409.164062 363.007812 409.207031 364.046875 408.941406 C 364.675781 408.714844 365.355469 408.472656 365.992188 408.289062 C 367.171875 407.695312 368.140625 406.84375 368.902344 405.738281 C 369.203125 405.175781 369.503906 404.613281 369.753906 404.058594 C 370.175781 402.820312 370.277344 401.550781 370 400.203125 Z M 370 400.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae4f13b253)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 314.699219 485.695312 C 313.96875 485.695312 313.375 485.101562 313.375 484.371094 C 313.375 471.863281 303.195312 461.683594 290.6875 461.683594 C 289.957031 461.683594 289.359375 461.089844 289.359375 460.355469 C 289.359375 459.625 289.957031 459.03125 290.6875 459.03125 C 294.109375 459.03125 297.425781 459.699219 300.550781 461.019531 C 303.570312 462.296875 306.277344 464.125 308.605469 466.449219 C 310.929688 468.777344 312.757812 471.488281 314.035156 474.503906 C 315.355469 477.628906 316.027344 480.945312 316.027344 484.367188 C 316.027344 485.101562 315.433594 485.695312 314.699219 485.695312 Z M 314.699219 485.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#133d3fce46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#315280f68a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a3e207108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 328.78125 436.195312 C 329.507812 436.292969 330.019531 436.960938 329.921875 437.6875 C 328.277344 450.085938 337.027344 461.515625 349.425781 463.160156 C 350.152344 463.257812 350.664062 463.925781 350.566406 464.652344 C 350.46875 465.378906 349.800781 465.886719 349.074219 465.792969 C 345.683594 465.34375 342.484375 464.242188 339.558594 462.519531 C 336.734375 460.855469 334.289062 458.691406 332.292969 456.078125 C 330.292969 453.464844 328.835938 450.539062 327.96875 447.378906 C 327.070312 444.109375 326.84375 440.730469 327.292969 437.339844 C 327.386719 436.613281 328.054688 436.101562 328.78125 436.195312 Z M 328.78125 436.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d59b73cce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9dd330c140)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ddef3bcc8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 291.738281 454.28125 C 291.917969 453.570312 292.640625 453.136719 293.347656 453.316406 C 305.480469 456.355469 317.828125 448.957031 320.867188 436.824219 C 321.046875 436.113281 321.769531 435.683594 322.480469 435.859375 C 323.191406 436.039062 323.621094 436.757812 323.445312 437.46875 C 322.613281 440.789062 321.15625 443.84375 319.113281 446.554688 C 317.140625 449.171875 314.710938 451.355469 311.890625 453.046875 C 309.070312 454.734375 305.996094 455.847656 302.757812 456.355469 C 299.40625 456.878906 296.023438 456.71875 292.707031 455.886719 C 291.992188 455.710938 291.5625 454.992188 291.738281 454.28125 Z M 291.738281 454.28125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06d62a3759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adbac3ccb5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31029c73dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 351.195312 470.445312 C 350.984375 471.148438 350.246094 471.546875 349.542969 471.339844 C 337.554688 467.761719 324.894531 474.601562 321.316406 486.589844 C 321.109375 487.289062 320.367188 487.691406 319.664062 487.480469 C 318.964844 487.269531 318.5625 486.53125 318.773438 485.828125 C 319.75 482.550781 321.339844 479.5625 323.5 476.945312 C 325.589844 474.417969 328.113281 472.347656 331.007812 470.78125 C 333.902344 469.21875 337.023438 468.246094 340.277344 467.882812 C 343.648438 467.511719 347.019531 467.816406 350.296875 468.796875 C 351.003906 469.003906 351.402344 469.742188 351.195312 470.445312 Z M 351.195312 470.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a24b08887)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 430.417969 358.371094 C 429.683594 358.371094 429.089844 357.773438 429.089844 357.042969 C 429.089844 344.535156 418.914062 334.355469 406.40625 334.355469 C 405.671875 334.355469 405.078125 333.761719 405.078125 333.03125 C 405.078125 332.296875 405.671875 331.703125 406.40625 331.703125 C 409.824219 331.703125 413.144531 332.371094 416.269531 333.691406 C 419.285156 334.96875 421.996094 336.796875 424.320312 339.121094 C 426.648438 341.449219 428.472656 344.160156 429.75 347.175781 C 431.074219 350.300781 431.742188 353.621094 431.742188 357.039062 C 431.746094 357.773438 431.148438 358.371094 430.417969 358.371094 Z M 430.417969 358.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1659b9f656)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09e29e4b40)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7e1b80c87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 444.496094 308.867188 C 445.222656 308.964844 445.734375 309.632812 445.636719 310.359375 C 443.992188 322.757812 452.742188 334.1875 465.140625 335.832031 C 465.867188 335.929688 466.378906 336.597656 466.28125 337.324219 C 466.1875 338.050781 465.519531 338.5625 464.792969 338.464844 C 461.402344 338.015625 458.199219 336.914062 455.277344 335.191406 C 452.453125 333.527344 450.007812 331.363281 448.007812 328.75 C 446.007812 326.140625 444.554688 323.210938 443.683594 320.054688 C 442.785156 316.78125 442.558594 313.402344 443.007812 310.011719 C 443.101562 309.285156 443.769531 308.773438 444.496094 308.867188 Z M 444.496094 308.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67d8798ffd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16be8ac131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28de8e3baa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 407.457031 326.953125 C 407.632812 326.242188 408.355469 325.808594 409.066406 325.988281 C 421.199219 329.027344 433.542969 321.628906 436.585938 309.496094 C 436.761719 308.785156 437.484375 308.355469 438.195312 308.53125 C 438.90625 308.710938 439.339844 309.433594 439.160156 310.144531 C 438.328125 313.460938 436.875 316.515625 434.832031 319.226562 C 432.859375 321.84375 430.429688 324.027344 427.605469 325.71875 C 424.785156 327.410156 421.710938 328.519531 418.476562 329.027344 C 415.121094 329.550781 411.742188 329.390625 408.421875 328.5625 C 407.710938 328.382812 407.277344 327.664062 407.457031 326.953125 Z M 407.457031 326.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#15d2870080)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#769e74aac7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa4fda6081)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfbfa",
    d: "M 466.910156 343.117188 C 466.699219 343.820312 465.960938 344.21875 465.257812 344.011719 C 453.273438 340.433594 440.609375 347.277344 437.035156 359.261719 C 436.824219 359.964844 436.082031 360.363281 435.382812 360.152344 C 434.679688 359.945312 434.28125 359.203125 434.488281 358.5 C 435.46875 355.226562 437.058594 352.234375 439.21875 349.621094 C 441.304688 347.09375 443.832031 345.019531 446.722656 343.457031 C 449.617188 341.890625 452.738281 340.917969 455.992188 340.554688 C 459.367188 340.183594 462.738281 340.492188 466.015625 341.46875 C 466.71875 341.675781 467.121094 342.417969 466.910156 343.117188 Z M 466.910156 343.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.630819, 1.964754, -1.953138, -0.62709, 534.550513, 360.082737)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.500103 1.49935 L 35.29337 1.500818 ",
    stroke: "#fcfbfa",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.964754, -0.630819, 0.62709, -1.953138, 555.067056, 409.523663)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.499 1.49996 L 35.29349 1.499033 ",
    stroke: "#fcfbfa",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrustrationsLogo);
export default __webpack_public_path__ + "static/media/frustrationsLogo.c62f8b90fcfb5e50416c3eb2b06e8d34.svg";
export { ForwardRef as ReactComponent };